import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class LoggerService {
    private isDev = !environment.production;

    log(...args: any[]) {
        if (this.isDev) console.log(...args);
    }

    warn(...args: any[]) {
        if (this.isDev) console.warn(...args);
    }

    error(...args: any[]) {
        console.error(...args);
    }
}